var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import Table from '../../../../components/Table/Table';
import Button from '../../../../components/Button';
import styled from 'styled-components';
import t from '../../../../lib/translate';
import Users from '../../hooks';
import LabelBox from '../../../../components/LabelBox';
import Icon from '../../../../components/Icon';
import { IconWrapper } from '../../../TemplatePage/components/TemplateList';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../../components/Loader';
export var ButtonWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  margin: 1em 0;\n  justify-content: flex-end;\n  button{\n    margin-left: 1em;\n  }\n"], ["\n  display: flex;\n  margin: 1em 0;\n  justify-content: flex-end;\n  button{\n    margin-left: 1em;\n  }\n"])));
export var StyledLabelBoxDivWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  max-width: 20rem;\n  flex-wrap: wrap\n"], ["\n  display: flex;\n  max-width: 20rem;\n  flex-wrap: wrap\n"])));
var UsersList = function () {
    var _a = Users.useContainer(), users = _a.users, isLoading = _a.isLoading;
    var navigate = useNavigate();
    var columns = useMemo(function () { return [{
            Header: t('users.table.headers.name'), accessor: 'fullName'
        }, {
            Header: t('users.table.headers.username'), accessor: 'username'
        }, {
            Header: t('users.table.headers.email'), accessor: 'email'
        }, {
            Header: t('users.table.headers.ownerParties'),
            id: 'ownerParties',
            accessor: function (user) {
                return _jsxs(StyledLabelBoxDivWrapper, { children: [" ", (user.ownerParties.map(function (ownerParty) { return _jsx(LabelBox, { label: ownerParty.name }, ownerParty.key); }))] });
            }
        }, {
            Header: t('users.table.headers.accessLevels'),
            id: 'accessLevels',
            accessor: function (user) {
                return _jsxs(StyledLabelBoxDivWrapper, { children: [" ", (user.permissions.filter(function (permission) { return !permission.startsWith('ALLOW_OWNERPARTY:'); }).map(function (permission) {
                            return _jsx(LabelBox, { label: t(permission) }, permission);
                        }))] });
            }
        }, {
            Header: '',
            id: 'editUser',
            accessor: function (user) {
                return _jsx(IconWrapper, { children: _jsx(Icon, { icon: "pencil-alt", onClick: function () { return navigate("/admin/useradmin/edit/".concat(user.username)); } }) });
            },
            disableSortBy: true
        }]; }, [history]);
    return (_jsxs("div", { children: [_jsx(ButtonWrapper, { children: _jsx(Button, { onClick: function () { return navigate('/admin/useradmin/create'); }, text: t('users.new') }) }), isLoading
                ? _jsx(Loader, {})
                : _jsx(Table, { columns: columns, data: users, pagination: false })] }));
};
export default UsersList;
var templateObject_1, templateObject_2;
